import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
  
// <React.StrictMode>
// </React.StrictMode>

const container = document.getElementById('root');
const app = (
  <div style={{width: '100%', height: '100%', padding: 0, margin: 0}}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </div>
);
  
const root = createRoot(container!);
root.render(app);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
